<template>
    <div id="loan(-geolocation-component">
        <div v-if="geolocation != null">
            <p class="text-sm">
                <span class="bold icon-position">
                    <feather-icon icon="MapPinIcon" svgClasses="h-5 w-5 mb-1 stroke-current text-primary" /> 
                    Geolocalización: 
                </span>
                <span @click.stop="popupActivo = true" class="cursor-pointer underline">
                    {{ geolocation }}
                </span>
            </p>
        </div>
        <div v-else>
            <p class="black">
                <span class="bold icon-position">
                    <feather-icon icon="MapPinIcon" svgClasses="h-5 w-5 mb-1 stroke-current text-primary" /> 
                    Geolocalización: 
                </span>
                No disponible
            </p>
        </div>

        <vs-popup class="mid-popup header-primary" :title="title" :active.sync="popupActivo">
            <div class="gmaps-embed">
                <iframe
                :src="mapSrc()"
                loading="lazy"
                allowfullscreen
                referrerpolicy="no-referrer-when-downgrade"
                frameborder="0">
                </iframe>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import formatHelper from '@mixins/formatHelper';
    export default {
        name: "LoanGeolocationComponent",
        mixins: [formatHelper],
        data: () => ({
            popupActivo: false,
            coords: null,
            zoom: 15
        }),
        props: {
            geolocation: String,
            title: {
                type: String,
                default: "Geolocalización de la creación del proyecto"
            }
        },
        async mounted() {
            this.coords = await this.latLongFormat(this.geolocation);
        },
        methods: {
            mapSrc() {
                if (this.geolocation != null) {
                    return `https://www.google.com/maps?q=${this.coords.latitude},${this.coords.longitude}&z=${this.zoom}&output=embed`;
                } else {
                    return "";
                }
            }
        },
    }
</script>

<style>

.icon-position .feather-icon {
    top: 7px;
}

.gmaps-embed {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 */
}
.gmaps-embed > iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

</style>